import React, { useEffect, useState } from "react";
import styles from "../styles/premium.module.css";
import { BACKEND_URL } from "../config";

const PremiumHandler = ({ isPremium, setIsPremium, showModal, setShowModal, errorMessage }) => {
    const [loading, setLoading] = useState(false);
    // Vérifie si un paiement est en attente et met à jour le statut premium après confirmation

    useEffect(() => {
        const checkPaymentStatus = async () => {
            if (sessionStorage.getItem("payment_pending")) {
                try {
                    const userId = sessionStorage.getItem("user_id");
                    const response = await fetch(`${BACKEND_URL}/user/${userId}`);
                    const data = await response.json();
                    console.log(data.isPremium)
                    
                    // Si l'utilisateur est bien premium après le paiement, on met à jour son statut
                    if (data.is_premium) {
                        
                        sessionStorage.removeItem("payment_pending");
                        sessionStorage.setItem("is_premium", "true");
                        setIsPremium(true);
                        setShowModal(false);
                    } else {
                        
                        sessionStorage.removeItem("payment_pending");
                    }
                } catch (error) {
                    console.error("Error checking premium status:", error);
                }
            }
        };

        checkPaymentStatus();
    }, [setIsPremium, setShowModal]);

    // Gère la redirection vers Stripe pour le paiement
    const handleUpgrade = async () => {
        setLoading(true);
        const userId = sessionStorage.getItem("user_id");

        if (!userId) {
            alert("Please log in first.");
            setLoading(false);
            return;
        }

        try {
            // Récupérer l'URL actuelle pour rediriger l'utilisateur au même endroit après paiement
            const currentPath = window.location.pathname + window.location.search;
            
            const response = await fetch(`${BACKEND_URL}/create-checkout-session`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    user_id: userId,
                    return_url: currentPath  // Envoyer l'URL actuelle
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.detail);
            }

            const data = await response.json();
            sessionStorage.setItem("payment_pending", "true");
            window.location.href = data.url;
        } catch (error) {
            alert(error.message); 
        }

        setLoading(false);
    };

    return (
        <>
            {showModal && (
                <div className={styles.modal} onClick={(e) => {
                    if (e.target.classList.contains(styles.modal)) {
                        setShowModal(false); // Ferme la modale si on clique en dehors
                    }
                }}>
                    <div className={styles.modalContent}>
                        <p>{errorMessage || "Advanced configuration is available for premium users only."}</p>
                        <button className={styles.upgradeButton} onClick={handleUpgrade} disabled={loading}>
                            {loading ? "Processing..." : "Subscribe to Premium"}
                        </button>
                        <button className={styles.cancelButton} onClick={() => setShowModal(false)}>Cancel</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default PremiumHandler;
